<template>
  <div class="products">
    <div
      class="product-item"
      v-for="(product, index) in top10Products"
      v-bind:key="index"
      v-on:click="goToProduct(product)"
    >
      <div class="strip-box">
        <div
          class="strip"
          :class="getProductTypeClass(product.visa_type)"
        ></div>
      </div>
      <div class="product-content">
        <div class="product-title" v-text="product.product_name"></div>
        <div class="product-center">
          <div class="score-box">
            <stars v-bind:score="getScore(product.sum_score)"></stars>
          </div>
          <div class="success-rate">
            <span>出签率</span>
            <span class="percent" v-text="product.pass_rate + '%'"></span>
          </div>
          <div
            class="original-price"
            v-text="'￥' + product.original_price / 100"
          ></div>
        </div>
        <div class="product-bottom">
          <div class="handle-period" v-text="product.need_days"></div>
          <div class="current-price">
            <span class="price-sign"
              >￥<span
                class="price-num"
                v-text="product.sell_price / 100"
              ></span
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import stars from './stars';

export default {
  name: 'recommendProducts',
  props: {
    products: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      top10Products:
        this.products.length >= 0 ? this.products.slice(0, 10) : this.products,
    };
  },
  components: {
    stars,
  },
  methods: {
    getProductTypeClass(typeName) {
      switch (typeName) {
        case '商务签':
          return 'blue-business';
        case '旅游签':
          return 'green-tourism';
        case '探亲访友签':
          return 'red-visiting-relatives';
        default:
          return 'purple-other';
      }
    },

    goToProduct(product) {
      this.$emit('product', product.visa_product_id);
    },

    getScore(score) {
      if (!score) return 0;
      return Math.floor(score);
    },
  },
};
</script>
<style scoped lang="less">
.products {
  background-color: #fff;
  margin-top: 0.15rem;
  display: flex;
  flex-direction: column;
  .product-item {
    display: flex;
    flex-direction: row;
    .strip-box {
      padding: 0.24rem 0;
      width: 0.27rem;
      display: flex;
      align-items: flex-end;
      .strip {
        border-radius: 0.03rem;
        width: 0.06rem;
        height: 0.4rem;
        background-repeat: no-repeat;
        background-position: center center;
        margin-bottom: 0.03rem;
      }
      .blue-business {
        background-image: url('../../static/img/blue-business@2x.png');
      }
      .green-tourism {
        background-image: url('../../static/img/green-tourism@2x.png');
      }
      .red-visiting-relatives {
        background-image: url('../../static/img/red-visiting-relatives@2x.png');
      }
      .purple-other {
        background-image: url('../../static/img/purple-other@2x.png');
      }
    }
    .product-content {
      padding: 0.24rem 0.12rem 0.24rem 0;
      flex: auto;
      border-bottom: 1px solid #f0f0f0;
      .product-title {
        color: #444;
        font-size: 0.16rem;
        line-height: 0.16rem;
        margin-bottom: 0.16rem;
      }
      .product-center {
        display: flex;
        align-items: center;
        .score-box {
          .star {
            background-color: red;
            width: 5px;
            height: 5px;
          }
        }
        .success-rate {
          margin-left: 0.16rem;
          font-size: 0.12rem;
          line-height: 0.12rem;
          flex: 1;
          color: #aaa;
          .percent {
            margin-left: 0.04rem;
          }
        }
        .original-price {
          width: 0.5rem;
          text-align: right;
          font-size: 0.12rem;
          line-height: 0.12rem;
          color: #aaa;
          text-decoration: line-through;
        }
      }
      .product-bottom {
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
        .handle-period {
          font-size: 0.12rem;
          line-height: 0.12rem;
          color: #aaa;
          flex: 1;
        }
        .current-price {
          color: #ff5a60;
          width: 0.5rem;
          text-align: right;
          .price-sign {
            font-size: 0.12rem;
            line-height: 0.12rem;
          }
          .price-num {
            font-size: 0.18rem;
            line-height: 0.18rem;
          }
        }
      }
    }
  }
}
</style>
